export default __webpack_public_path__ + "static/notebooks-ghg-92c604910ac5044a461c565a29968aec.png";